import React, { useState } from 'react';
import { Form, Col } from 'react-bootstrap';
import Button from '../../../components/Button';
import AlertError from '../../../components/AlertError';
import AlertSuccess from '../../../components/AlertSuccess';
import Fieldset from '../../../components/Fieldset';
import api from '../../../services/api';

const RelatorioAnual: React.FC = () => {
    const [ano, setAno] = useState(new Date().getFullYear());
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const gerarRelatorio = async () => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await api.get(`/api/v1/autorizacoes-cibio/relatorios/anual?ano=${ano}`, {
                responseType: 'blob'
            });

            // Criar URL para download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Relatorio_Anual_CIBIO_${ano}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            setSuccess(true);
        } catch (err: any) {
            setError(err.response?.data?.message || 'Erro ao gerar relatório');
        } finally {
            setLoading(false);
        }
    };

    const anosDisponiveis = [];
    const anoAtual = new Date().getFullYear();
    for (let i = anoAtual; i >= 2020; i--) {
        anosDisponiveis.push(i);
    }

    return (
        <div className="container container-fluid">
            <h3>RELATÓRIO ANUAL CIBIO</h3>
            
            {error && (
                <AlertError message={error} />
            )}

            {success && (
                <AlertSuccess message="Relatório gerado com sucesso! O download deve ter iniciado automaticamente." />
            )}

            <Form>
                <Fieldset title="Geração de Relatório">
                    <Form.Row className="row-custom">
                        <Form.Group as={Col} md={6}>
                            <Form.Label>
                                <strong>Selecione o Ano:</strong>
                            </Form.Label>
                            <Form.Control
                                as="select"
                                value={ano}
                                onChange={(e) => setAno(parseInt(e.target.value))}
                                disabled={loading}
                            >
                                {anosDisponiveis.map(anoOption => (
                                    <option key={anoOption} value={anoOption}>
                                        {anoOption}
                                    </option>
                                ))}
                            </Form.Control>
                            <Form.Text className="text-muted">
                                Selecione o ano para o qual deseja gerar o relatório
                            </Form.Text>
                        </Form.Group>
                    </Form.Row>
                    <div className="button-position">
                        <Button
                            title={loading ? "Gerando Relatório..." : "Gerar Relatório Anual"}
                            contained={true}
                            type="button"
                            onClick={gerarRelatorio}
                            isLoading={loading}
                        />
                    </div>
                </Fieldset>

                <Fieldset title="O que inclui o relatório">
                    <Form.Row className="row-custom">
                        <Col md={6} className="mb-3">
                            <div className="border rounded p-3 h-100 bg-white">
                                <div className="d-flex align-items-center mb-1">
                                    <strong>Resumo Geral</strong>
                                </div>
                                <small className="text-muted">Estatísticas consolidadas de todos os módulos</small>
                            </div>
                        </Col>
                        <Col md={6} className="mb-3">
                            <div className="border rounded p-3 h-100 bg-white">
                                <div className="d-flex align-items-center mb-1">
                                    <strong>AMI</strong>
                                </div>
                                <small className="text-muted">Movimentações internas e transportes</small>
                            </div>
                        </Col>
                        <Col md={6} className="mb-3">
                            <div className="border rounded p-3 h-100 bg-white">
                                <div className="d-flex align-items-center mb-1">
                                    <strong>AAC</strong>
                                </div>
                                <small className="text-muted">Atividades de contenção e ensaios</small>
                            </div>
                        </Col>
                        <Col md={6} className="mb-3">
                            <div className="border rounded p-3 h-100 bg-white">
                                <div className="d-flex align-items-center mb-1">
                                    <strong>AE</strong>
                                </div>
                                <small className="text-muted">Exportações e destinos</small>
                            </div>
                        </Col>
                        <Col md={6} className="mb-3">
                            <div className="border rounded p-3 h-100 bg-white">
                                <div className="d-flex align-items-center mb-1">
                                    <strong>AI</strong>
                                </div>
                                <small className="text-muted">Importações e origens</small>
                            </div>
                        </Col>
                        <Col md={6} className="mb-3">
                            <div className="border rounded p-3 h-100 bg-white">
                                <div className="d-flex align-items-center mb-1">
                                    <strong>Análise Regulatória</strong>
                                </div>
                                <small className="text-muted">Métricas de performance e observações</small>
                            </div>
                        </Col>
                    </Form.Row>

                    <div className="mt-2">
                        <small className="text-muted">
                            <strong>Formato:</strong> Excel (.xlsx) com múltiplas abas organizadas
                        </small>
                    </div>
                </Fieldset>
            </Form>
        </div>
    );
};

export default RelatorioAnual;